import './App.scss'
import './config/i18s'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { Layout } from './pages/layout'
import { loadConfig } from './store/slices/appConfigSlice'
import { RenderError } from './components/error/RenderError'
import { store } from './store/store'
import { ROUTES } from './route/routes.constants'
import { ClivLogin } from './features/auth/ClivLogin'
import { listenForMessages } from './serviceworker/mediator'
import { useSentryUser } from './hooks/useSentryUser'
import { NavigationProvider } from './hooks/useNavigationContext'
import { useEffect } from 'react'
import { ensurePersistentStorage, logStorageEstimate } from './utils/storage.utils'
import { tryInspectSsoSilentLogin } from './services/trySsoSilentLogin'
import { WithNoAuth } from './features/auth/WithNoAuth'

function App() {
  useEffect(() => {
    // eslint-disable-next-line no-console -- login diagnostics
    console.debug('[inspect-auth]', 'App mount: tryInspectSsoSilentLogin()');
    void tryInspectSsoSilentLogin()
  }, [])
  useEffect(() => {
    const cleanup = listenForMessages();
    (async () => {
      try {
        const granted = await ensurePersistentStorage()
        console.log('Persistent granted?', granted)
        await logStorageEstimate()
      } catch (error) {
        console.error('Error checking persistent storage', error)
      }
    })();

    return cleanup;
  }, [])
  store.dispatch(loadConfig())
  useSentryUser()
  return (
    <Router>
      <Sentry.ErrorBoundary
        fallback={<RenderError />}
        onError={(error, componentStack) => {
          // Ensure error is captured when fallback renders
          Sentry.captureException(error, { extra: { componentStack } });
          // Also log to console to aid debugging when Sentry is disabled
          // eslint-disable-next-line no-console
          console.error('React error boundary captured an error', error, componentStack);
        }}
      >
        <NavigationProvider>
          <Routes>
            <Route path={ROUTES.ROOT} element={<WithNoAuth><ClivLogin /></WithNoAuth>} />
            <Route path='/*' element={<Layout />}></Route>
          </Routes>
        </NavigationProvider>
      </Sentry.ErrorBoundary>
    </Router>
  )
}

export default App
